import Text from 'components/shared/Text'
import { useIntl } from 'react-intl'
import ModalInfo from 'components/shared/ModalInfo'

interface RemovePhotoModalProps {
    onLinkClick: () => void
    onButtonClick: () => void
    isOpened: boolean
}

const RemovePhotoModal = ({
    onLinkClick,
    onButtonClick,
    isOpened,
}: RemovePhotoModalProps) => {
    const { formatMessage } = useIntl()
    return (
        <ModalInfo
            variant="secondary"
            buttonLabel={formatMessage({
                id: 'annual.btn.remove_photo',
                defaultMessage: 'Usuń zdjęcie',
            })}
            linkLabel={formatMessage({
                id: 'global.btn.cancel',
                defaultMessage: 'Anuluj',
            })}
            onLinkClick={onLinkClick}
            onButtonClick={onButtonClick}
            isOpened={isOpened}
            testIdPrefix="unlimited-photo-remove-modal"
        >
            <Text variant="heading3" mb={16}>
                {formatMessage({
                    id: 'annual.modal.remove_photo_header',
                    defaultMessage: 'Czy na pewno chcesz usunąć zdjęcie?',
                })}
            </Text>
            <Text variant="body" color="grayscale_900">
                {formatMessage({
                    id: 'annual.modal.remove_photo_description',
                    defaultMessage:
                        'Wgranie zdjęcia jest konieczne, aby przejść do następnego kroku.',
                })}
            </Text>
        </ModalInfo>
    )
}

export default RemovePhotoModal
